import { useState, useEffect } from 'react'
import KnowledgeDatatableComponentGridView from '../../../components/UI/KnowledgeDatatableComponent/KnowledgeDatatableComponentGridView'
import './AllKnowledge.scss'

import { useTranslation } from 'react-i18next'
import { Box, Stack, Typography } from '@mui/material'
import KnowledgeCarousel from '@/components/UI/KnowledgeDatatableComponent/KnowledgeCrousel'
import { useHeader } from '@/hooks/useHeader'

const AllKnowledge = () => {
  const { t } = useTranslation('translation')
  const { setHeaderText } = useHeader()
  const [showQuickAccess, setShowQuickAccess] = useState(true)

  useEffect(() => {
    setHeaderText('Knowledge')
  }, [setHeaderText])

  return (
    <section className="page-mid-wraper h-without-foter">
      <Box
        sx={{
          position: 'sticky',
          zIndex: 10,
          background: 'white',
          pb: '16px',
        }}
      >
        <KnowledgeCarousel />
      </Box>

      <KnowledgeDatatableComponentGridView />
    </section>
  )
}

export default AllKnowledge
